<template>
    <Head title="Fale Conosco" />
    <AuthenticatedLayout>
        <Heading title="Fale Conosco" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="min-h-[80vh]">
                <section class="grid grid-cols-2 xl:grid-cols-3 sm:grid-cols-1 gap-7 py-8 xl:px-[16vw] xl:pt-18 xl:pb-18 px-5">
                    <div class="bg-white w-full max-w-[435px] h-[219px] rounded-2xl border border-primary mb-5 xl:mb-0">
                        <div class="flex flex-col justify-between h-full xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left">
                            <div class="flex flex-col justify-between items-start mb-4">
                                <p class="text-[20px] font-bold text-primary">Perguntas Frequentes</p>
                                <p class="text-[14px]">Tire suas dúvidas de forma rápida.</p>
                            </div>

                            <a href="/faq"
                                class="max-w-[180px]
                                whitespace-nowrap
                                grid
                                justify-items-center
                                items-center
                                font-semibold
                                border-primary
                                bg-white
                                border rounded-2xl
                                hover:bg-gray-300
                                transition-all
                                p-2
                                sm:mt-2"
                            >
                                <p class="text-[16px] text-primary font-bold">Acessar Perguntas</p>
                                <!-- <Icon name="LinkExterno" class="w-4 h-4"/> -->
                            </a>
                        </div>
                    </div>
                    <div class="bg-white w-full max-w-[435px] h-[219px] rounded-2xl border border-primary mb-6 xl:mb-0">
                        <div class="flex flex-col justify-between w-full h-full xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left gap-y-4 xl:gap-0">
                            <div class="flex flex-col gap-y-2 items-start">
                                <p class="text-[24px] font-bold text-primary">Email</p>
                                <p class="text-[14px]">Envie suas dúvidas ou sugestões e receba a resposta por email. </p>
                            </div>
                            <a href="/contact-form"
                                class="max-w-[148px]
                                whitespace-nowrap
                                grid
                                justify-items-center
                                items-center
                                font-semibold
                                border-primary
                                bg-white
                                border rounded-2xl
                                hover:bg-gray-300
                                transition-all
                                p-2
                                sm:mt-2"
                            >
                                <p class="text-[16px] text-primary font-bold">Escrever Email</p>
                            </a>
                        </div>
                    </div>

                    <div class="bg-white w-full max-w-[435px] max-h-[219px] rounded-2xl border border-primary">
                        <div class="flex flex-col xl:gap-y-16 xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left">
                            <div class="flex flex-col gap-y-2 justify-between">
                                <p class="text-[24px] font-bold text-primary">Ligação</p>
                                <p class="text-[14px]">Fale com um agente de suporte:</p>
                                <!-- <p class="text-[14px] text-primary font-bold">0800-0000 (Capitais e grandes centros)</p>
                                <p class="text-[14px] text-primary font-bold">0800-0001 (Demais cidades e regiões)</p> -->
                                <p class="text-[14px] text-primary font-bold">0800 750 5548</p>
                                <p class="text-[14px]">Atendimento disponível de segunda a sexta, das 10h às 17h, exceto feriado.</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="bg-white w-full max-w-[435px] h-[219px] rounded-2xl border border-primary mb-6 xl:mb-0">
                        <div class="flex flex-col justify-between w-full h-full xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left gap-y-4 xl:gap-0">
                            <div class="flex flex-col gap-y-2 items-start">
                                <p class="text-[24px] font-bold text-primary">Sugestões</p>
                                <p class="text-[14px]">Envie sua sugestão para o Vença e nos ajude a melhorar a sua experiência.</p>
                            </div>
                            <a href="/contact-form/sugest"
                                class="max-w-[148px]
                                whitespace-nowrap
                                grid
                                justify-items-center
                                items-center
                                font-semibold
                                border-primary
                                bg-white
                                border rounded-2xl
                                hover:bg-gray-300
                                transition-all
                                p-2
                                sm:mt-2"
                            >
                                <p class="text-[16px] text-primary font-bold">Escrever Sugestão</p>
                            </a>
                        </div>
                    </div>
            </section>

        </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue'
import ContactForm from '@/Pages/ContactForm.vue'
import ContactFormSugest from '@/Pages/ContactFormSugest.vue'
import { Head } from '@inertiajs/inertia-vue3';
import ButtonContactForm from '@/Components/ButtonContactForm.vue';
import Heading from '@/Components/UI/Texts/Heading.vue';
import Icon from '@/Components/UI/Icons/Icon.vue';
// import ContactFormSugestVue from './ContactFormSugest.vue'

export default {
    components: {
        AuthenticatedLayout,
        Head,
        ContactForm,
        ContactFormSugest,
        ButtonContactForm,
        Heading,
        Icon
    },
}
</script>
